import { diffComparisonValueFormat } from '@workalizer/shared/types';
export var DEMO_ORG_SUMMARY_SEGMENTS = {
    emails: [
        {
            value: '4.8k',
            diff: { diffString: '+9%', diff: 9, comparisonValue: 4404 }
        },
        {
            value: '4.2k',
            diff: { diffString: '+6%', diff: 6, comparisonValue: 3962 }
        }
    ],
    messages: [
        {
            value: '18.3k',
            diff: { diffString: '+14%', diff: 14, comparisonValue: 16053 }
        },
        {
            value: '17.1k',
            diff: { diffString: '+11%', diff: 11, comparisonValue: 15405 }
        }
    ],
    meetings: [
        {
            value: '1204',
            diff: { diffString: '-3%', diff: -3, comparisonValue: 1241 }
        },
        {
            value: '912h 10m',
            diff: {
                diffString: '+4%',
                diff: 4,
                comparisonValue: 3153600,
                comparisonValueFormat: diffComparisonValueFormat.durationSeconds
            }
        }
    ],
    external: [
        { value: '22%', diff: { diffString: '+3%', diff: 3, comparisonValue: 21 } },
        {
            value: '12%',
            diff: { diffString: '-1%', diff: -1, comparisonValue: 12 }
        },
        { value: '18%', diff: { diffString: '+5%', diff: 5, comparisonValue: 17 } }
    ]
};
export var DEMO_TEAM_SUMMARY_SEGMENTS = {
    emails: [
        { value: '252', diff: { diffString: '+22%', diff: 22 } },
        { value: '165', diff: { diffString: '+23%', diff: 23 } }
    ],
    messages: [
        { value: '31', diff: { diffString: '+63%', diff: 63 } },
        { value: '30', diff: { diffString: '+30%', diff: 30 } }
    ],
    meetings: [
        { value: '122', diff: { diffString: '+7%', diff: 7 } },
        { value: '83h 54m', diff: { diffString: '+12%', diff: 12 } }
    ],
    external: [
        { value: '16%', diff: { diffString: '-5%', diff: -5 } },
        { value: '19%', diff: { diffString: '-16%', diff: -16 } },
        { value: '26%', diff: { diffString: '+2%', diff: 2 } }
    ]
};
var SUMMARY_CARD_IDS = [
    'emails',
    'messages',
    'meetings',
    'external'
];
export var buildDemoCommunicationNetworkGraphSummaryCards = function (isOrgScope) {
    var segmentsById = isOrgScope
        ? DEMO_ORG_SUMMARY_SEGMENTS
        : DEMO_TEAM_SUMMARY_SEGMENTS;
    return SUMMARY_CARD_IDS.map(function (id) { return ({
        id: id,
        segments: segmentsById[id]
    }); });
};
